module.exports = __webpack_public_path__ + "img/silence.5e374909.png";